module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-bulb-8fc8d398caf5c4852b1e8baec2191b55.svg";